const HeaderBlock = ({ logoUrl, companyName, showCompanyName }) => {
  if (!logoUrl && !(showCompanyName && companyName)) return null

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] px-4 sm:px-5 py-3 sm:py-4 mb-4 flex flex-wrap items-center gap-2.5 sm:gap-3">
      {logoUrl && (
        <img
          src={logoUrl}
          alt={companyName || "logo"}
          className="h-8 sm:h-10 w-auto max-w-[120px] sm:max-w-[160px] object-contain shrink-0"
        />
      )}
      {showCompanyName && companyName && (
        <span className="text-sm sm:text-base font-semibold text-[#1F2733] break-words min-w-0">
          {companyName}
        </span>
      )}
    </div>
  )
}

export default HeaderBlock
